<template>
  <div class="home">
    <Header></Header>
    <Technology class="Technology"></Technology>
     <float></float>
    <Footer></Footer>
   
  </div>
</template>

<script>
import Header from '@/components/header'
import Technology from '@/views/technology/index'
import Footer from '@/components/footer'
import float from '@/components/float'
export default {
  name: "Home",
  components: { Header,Technology,Footer,float },
};
</script>

<style scoped>
.Technology{
  margin-top:168px;
}
@media screen and (max-width: 768px){
  .Technology{
  margin-top:80px;
}
}
</style>





// WEBPACK FOOTER //
// src/views/Home.vue